import { IcGroup } from '@assets/icons/24x24';
import { HStack, Icon, Text, VStack } from '@chakra-ui/react';

import { GroupLight } from '@/types/authent/groups.types';

type LightProps = {
  group: GroupLight;
  isActiveGroup: boolean;
};

export default function GroupLightCard({ group, isActiveGroup }: Readonly<LightProps>) {
  return (
    <VStack
      gap={2}
      width="334px"
      alignItems="start"
      backgroundColor="blue.800"
      padding={3}
      className="group"
      clipPath="polygon(0 0, 100% 0, 100% calc(100% - 6px), calc(100% - 6px) 100%, 0 100%, 0 0)"
    >
      <HStack width="100%">
        <Text color="neutral.200" textStyle="xl">
          {group.name}
        </Text>
        {isActiveGroup && <Icon as={IcGroup} boxSize="24px" color="blue.500" marginLeft="auto" />}
      </HStack>
    </VStack>
  );
}
